export default __webpack_public_path__ + "static/media/stepsLOF.cf9a3903.png";